import { render, staticRenderFns } from "./LecturePlayerPopup.vue?vue&type=template&id=8c19250e&scoped=true&"
import script from "./LecturePlayerPopup.vue?vue&type=script&lang=js&"
export * from "./LecturePlayerPopup.vue?vue&type=script&lang=js&"
import style0 from "./LecturePlayerPopup.vue?vue&type=style&index=0&id=8c19250e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c19250e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
